export default "__VITE_ASSET__C$E8oXzY__"